import { FC } from "react";
import type { ColumnsType } from "@payping/web-components/components/table/types";
import { Collapse, Table } from "@payping/web-components";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";
import type { ScheduleInvoiceDetails } from "@payping/api";
import { DashboardRoutes } from "@/router/constant";
import { Link } from "react-router-dom";

import { useAppTranslation } from "@/utils/useAppTranslation";
import { ScheduleInvoiceDatesProps } from "./type";

const ScheduleInvoiceDates: FC<ScheduleInvoiceDatesProps> = ({ data, count = data.length }) => {
  // =========================================
  // Init
  // =========================================
  const { t } = useAppTranslation();
  const columns: ColumnsType<ScheduleInvoiceDetails> = [
    {
      dataIndex: "code",
      key: "code",
      render(value) {
        return <Link to={DashboardRoutes.myShop.invoice.list.url.replace(":code", value)}>{value}</Link>;
      },
      title: t("invoice.create.base.scheduleInvoiceDates.invoiceCode"),
    },
    {
      dataIndex: "sendDate",
      key: "sendDate",
      render(sendDate: string): string {
        if (sendDate)
          // return `${toJalali({ date: sendDate, toFormat: dateFormats.ui.time }).string} - ${
          //   toJalali({ date: sendDate, toFormat: dateFormats.ui.jalaliDate }).string
          // }`;
          return `${toJalali({ date: sendDate, toFormat: dateFormats.ui.jalaliDate }).string}`;
        return "-";
      },
      title: t("invoice.create.base.scheduleInvoiceDates.sendDate"),
    },
    {
      dataIndex: "payedDateTime",
      key: "payedDateTime",
      render(payedDateTime: string): string {
        if (payedDateTime)
          return `${toJalali({ date: payedDateTime, toFormat: dateFormats.ui.time }).string} - ${
            toJalali({ date: payedDateTime, toFormat: dateFormats.ui.jalaliDate }).string
          }`;
        if (payedDateTime === null) return t("invoice.create.base.scheduleInvoiceDates.unpaid");
        return "-";
      },
      title: t("invoice.create.base.scheduleInvoiceDates.payDate"),
    },
    {
      dataIndex: "status",
      key: "status",
      render(status: number): string {
        switch (status) {
          case 0:
            return t("invoice.create.base.invoiceStatus.draft");
          case 1:
            return t("invoice.create.base.invoiceStatus.awaitingPayment");
          case 2:
            return t("invoice.create.base.invoiceStatus.paid");
          case 3:
            return t("invoice.create.base.invoiceStatus.delayed");
          case 4:
            return t("invoice.create.base.invoiceStatus.canceled");
          case 5:
            return t("invoice.create.base.invoiceStatus.all");
          case 6:
            return t("invoice.create.base.invoiceStatus.returned");
          case 7:
            return t("invoice.create.base.invoiceStatus.notSynced");
          default:
            return "-";
        }
      },
      title: t("invoice.create.base.scheduleInvoiceDates.status"),
    },
  ];
  const dataSource = [...data];
  for (let i = data.length; i < count; i += 1) {
    dataSource.push({ code: undefined, payedDateTime: undefined, sendDate: undefined, status: undefined });
  }

  // =========================================
  // Render
  // =========================================
  return (
    <Collapse>
      <Collapse.Panel key={0} header={t("invoice.create.base.scheduleInvoiceDates.title")}>
        <Table hasIdColumn dataSource={data} columns={columns} />
      </Collapse.Panel>
    </Collapse>
  );
};

export default ScheduleInvoiceDates;
